import { render, staticRenderFns } from "./LeftMenuLayout.vue?vue&type=template&id=772e4f06&scoped=true"
import script from "./LeftMenuLayout.vue?vue&type=script&lang=js"
export * from "./LeftMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e4f06",
  null
  
)

export default component.exports